/**
 * In memory default config
 * */
const inMemoryDefaultConfig = {
  // By default, check for cache expiry every 100 ms
  // Reducing this value might create performance issues
  expiryCheckInterval: 100
};

export default inMemoryDefaultConfig;
